<script lang="ts" setup>
	defineProps<{
		imgSrc: string
		name: string
		createdDate: string
		content: string
		format?: string
	}>()
	const { formatDate, estimateReadingTime } = useCustomDate()
</script>
<template>
	<div>
		<client-only>
			<div class="flex items-center gap-4 pb-1" data-label="Author">
				<div class="flex-none h-[40px] w-[40px] bg-gray-100 rounded-full">
					<img
						loading="lazy"
						:src="imgSrc"
						height="40"
						width="40"
						:alt="name"
						class="object-cover h-[40px] w-[40px] bg-gray-100 rounded-full"
					/>
				</div>
				<div>
					<address class="font-medium not-italic text-base text-gray-700">By {{ name }}</address>
					<div class="inline-flex font-normal flex-wrap items-center gap-y-1 gap-x-2 text-sm text-gray-600">
						<time
							><slot name="time" :value="formatDate(createdDate)">
								{{ formatDate(createdDate) }}</slot
							></time
						>
						<svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="2" cy="2.5" r="2" fill="#475467" />
						</svg>
						<span class="text-gray-500">
							{{ estimateReadingTime(content || null)?.minutes ?? 0 }} min read
						</span>
					</div>
				</div>
			</div>
		</client-only>
	</div>
</template>

<style></style>
